import React, { useReducer, useEffect } from 'react';
import './App.css';
import 'assets/styles.css';
import { SnackbarProvider } from 'notistack';
import { AuthContext } from 'auth/AuthContext';
import { AuthValidation } from 'auth/AuthValidation';
import { AppRouter } from 'routes/AppRouter';
import authService from 'auth/AuthService';

const init = () => authService.getSessionInfo();

function App() {
  const [permision, dispatch] = useReducer(AuthValidation, {}, init);

  useEffect(() => {
      localStorage.setItem('permision', JSON.stringify(permision));
  }, [permision]);

  return (
    <AuthContext.Provider value={{ permision, dispatch }}>
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={4000}
        anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
              }}
      >
        <AppRouter />
      </SnackbarProvider>
    </AuthContext.Provider>
  );
}

export default App;
